import { months } from "./chars";
let date = new Date();
let day = date.getDate();
let month = date.getMonth();
let year = date.getFullYear();
let fullDate = months[month] + " " + day + ", " + year;

export { fullDate };
